import React, { Component, useEffect, useState } from 'react';
import HeaderLogin from '../../components/HeaderLogin';
import authAPI from '../../api/authAPI';
import { useLocation, useNavigate } from 'react-router';
import { Button, Spinner } from 'react-bootstrap';
import MasterPage from '../../layouts/MasterPage';

const Login = (props) => {
  const [error, setError] = useState('');
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  let statePre = useLocation();
  useEffect(() => {
    console.log(statePre);
    if (props?.mobile) setMobile(props.mobile);
  }, [props?.mobile]);

  const navigate = useNavigate();
  const onSubmit = async () => {
    if (mobile.length === 11) {
      setLoading(true);

      authAPI
        .login(mobile)
        .then((res) => {
          props.setMobile(mobile);
          navigate('/otp', { state: { mobile: mobile } });
        })
        .catch((e) => {
          if (e.response) {
          }
        })
        .finally(() => setLoading(false));
    } else setError('شماره موبایل باید ۱۱ رقمی باشه');
  };
  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      onSubmit();
    }
  };
  return (
    <MasterPage>
      <div className="structure-page login p-4 body ">
        <div className="w-100">
          <HeaderLogin />

          <div className="form-group">
            <label htmlFor="mobile" className="tip">
              برای ورود، شماره موبایل خود را وارد کنید.
            </label>
            <input
              type="number"
              onChange={(e) => setMobile(e.target.value)}
              className="form-control w-100 inputs py-2"
              value={mobile}
              onKeyDown={onKeyDown}
              placeholder="شماره موبایل"
            />
            <small id="emailHelp" className="form-text text-muted">
              برای مثال: ۰۹۰۱۶۶۱۲۸۲۰
            </small>
            {error != '' && (
              <div className="invalid-feedback d-block">{error}</div>
            )}
          </div>
        </div>
        <Button
          variant="dark"
          disabled={mobile.length != 11}
          className="btn btn-submit d-flex align-items-center justify-content-center "
          onClick={onSubmit}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              className="p-2"
              role="status"
              aria-hidden="true"
            />
          ) : (
            ' ادامه'
          )}
        </Button>
      </div>
    </MasterPage>
  );
};

export default Login;
